import Inputmask from 'inputmask/dist/inputmask/inputmask.phone.extensions'
export default function () {
  const moduleName = 'inputMask'

  Array.from(document.querySelectorAll('[type="tel"]')).forEach((wrapper) => {
    if (wrapper.dataset[moduleName + 'Init'] === 'true') return
    wrapper.dataset[moduleName + 'Init'] = 'true'

    new Inputmask({
      mask: '+7 (999) 999-99-99',
      placeholder: '_',
      clearIncomplete: true,
      showMaskOnHover: false
    }).mask(wrapper)

    wrapper.addEventListener('input', () => {
      if (wrapper.inputmask) {
        if (wrapper.inputmask.isComplete()) {
          wrapper.classList.add('inputmask-complete')
        } else {
          wrapper.classList.remove('inputmask-complete')
        }
      } else {
        if (wrapper.value !== '') {
          wrapper.classList.add('inputmask-complete')
        } else {
          wrapper.classList.remove('inputmask-complete')
        }
      }
    })
  })
};
